import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import { CurrentDirectionContextProviderToggle } from '../../utils/dimensions';
export var TableContent = function () { return (React.createElement(React.Fragment, null,
    React.createElement(CurrentDirectionContextProviderToggle, null,
        React.createElement(RampWithNameTransform, { rampName: "HeaderBase" })),
    React.createElement(RampWithNameTransform, { rampName: "BodyBase" }),
    React.createElement(CurrentDirectionContextProviderToggle, null,
        React.createElement(RampWithNameTransform, { rampName: "FooterBase" })))); };
